const LOCAL_STORAGE_KEYS = {
  // Used to persist app language during reload
  appLanguage: "instacar-app-language",
  // Tracks whether the permissions guide page has been shown to the user
  permissionsGuideSeen: "permissions-guide-seen",
  // Tracks whether the claim marker guide modal has been auto-shown (suffixed with the session id)
  claimGuideSeen: "claim-guide-seen",
}

export { LOCAL_STORAGE_KEYS }
